<template>

  <div class="container">
    <h3 class="main-title">Comprobar identidad</h3>
    <div class="row">
      <div class="column">
        <p class="alert" v-if="mustCheck">Debes comprobar tu identidad para continuar completando tu Perfil de inversionista. Si tienes dudas contáctanos al e-mail <b class="-green">contacto.mx@cumplo.com</b> o llámanos al teléfono <b class="-green">(55) 7100 2310</b> para ayudarte.</p>
        <p class="alert" v-if="sameStep">La comprobación de tu identidad puede estar incompleta, o aún debe estar procesándose. Espera unos segundos y vuelve a presionar el botón <b>Siguiente</b>.</p>
      </div>
    </div>
    <div class="row row-responsive">
      <div class="column column-xs-100 column-sm-50">
        <p>Por tu seguridad, necesitaremos confirmar tu identidad. El servicio <a href="https://getmati.com/" target="_blank">Mati</a> permite que te saques una selfie y subas documentos como tu identificación / pasaporte y comprobante de residencia. Haz clic en el botón y sigue las instrucciones hasta completar el proceso.</p>
      </div>
      <div class="column column-xs-100 column-sm-50 centering">
        <button class="button-button-large button-secondary" :disabled="successCheck" @click="openModal()">Confirmar tu identidad</button>
      </div>
    </div>
    <div class="row">
      <div class="column">
        <p class="legend">Tu información será guardada de forma segura y encriptada, conforme las <a href="/static/pdf/politicas-privacidad-mx.pdf" target="_blank">Políticas de Privacidad</a> de Cumplo México.</p>
      </div>
      <div class="column">
        <button class="button float-right" @click.prevent="submit()" :disabled="!successCheck">Siguiente</button>
      </div>
    </div>
    <modal name="modal-identity-proof" classes="modal-investment v--modal-box v--modal" height="auto" width="620" :scrollable="true" :adaptive="true" @before-close="closeModal()">
      <div class="window-header">
        <h3 class="title">Confirmar tu identidad:</h3>
        <button class="button-close" @click="$modal.hide('modal-identity-proof')">×</button>
      </div>
      <div class="modal-content">
        <NotAvailable :returnButton="false"/>
      </div>
    </modal>
  </div>

</template>

<script>
import mixins from '@/mixins/index'
import httpRequestMixin from '@/mixins/httpRequestMixin'
import NotAvailable from '@/components/NotAvailable'

export default {
  name: 'StepIdentityProof',
  data () {
    return {
      mustCheck: false,
      sameStep: false,
      successCheck: false
    }
  },
  mixins: [mixins, httpRequestMixin],
  components: {
    NotAvailable
  },
  methods: {
    openModal: function () {
      this.$modal.show('modal-identity-proof')
      sessionStorage.removeItem('exitedSdk')
    },
    closeModal: function () {
      this.mustCheck = sessionStorage.getItem('sofom_exitedSdk')
      this.successCheck = sessionStorage.getItem('sofom_userFinishedSdk')
    },
    checkCurrentStep: async function () {
      await this.$store.dispatch('refreshToken')
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/profile/steps/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      }
      const response = await this.httpRequest(options)
      if (response.status === 200) {
        let step = response.data.step
        if (step === 3) {
          this.sameStep = true
        } else if (step === -1) {
          step = 9
        }
        sessionStorage.removeItem('userFinishedSdk')
        sessionStorage.removeItem('email')

        this.$store.dispatch('setCurrentStep', step)
      }
    },
    submit: function () {
      this.checkCurrentStep()
    }
  }
}

</script>

<style lang="scss" scoped>

.alert {
  padding: 1rem;
  border: 1px solid $red;
  border-radius: 6px;
  background-color: $white;
}

.modal-content {
  padding: 0;
}

.iframe {
  width: 100%;
  height: 90vh;
}

.legend {
  font-size: .8em;
}

.button-mati {
  border: 1px solid $green;
  border-radius: 5px;
}

.centering {
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>



// WEBPACK FOOTER //
// src/views/userProfile/profileSteps/StepIdentityProof.vue